import * as THREE from "three";
import { createPositionHelper } from "./createPositionHelper";

const POSITION_HELPER_SIZE = 0.01;
const POSITION_HELPER_OFFSET = 1;

function createGlobeVisualizationHelper() {
  const group = new THREE.Group();

  const northVisualizationObject3D = createPositionHelper({ color: 0xff0000 });
  northVisualizationObject3D.scale.setScalar(POSITION_HELPER_SIZE);
  northVisualizationObject3D.position.set(0, POSITION_HELPER_OFFSET + POSITION_HELPER_SIZE, 0);

  const southVisualizationObject3D = createPositionHelper({ color: 0x0000ff });
  southVisualizationObject3D.scale.setScalar(POSITION_HELPER_SIZE);
  southVisualizationObject3D.position.set(0, -POSITION_HELPER_OFFSET - POSITION_HELPER_SIZE, 0);

  const nullIslandVisualizationObject3D = createPositionHelper({ color: 0x00ff00 });
  nullIslandVisualizationObject3D.scale.setScalar(POSITION_HELPER_SIZE);
  nullIslandVisualizationObject3D.position.set(0, 0, POSITION_HELPER_OFFSET + POSITION_HELPER_SIZE);

  group.add(northVisualizationObject3D);
  group.add(southVisualizationObject3D);
  group.add(nullIslandVisualizationObject3D);

  return group;
}

export { createGlobeVisualizationHelper };
